(() => {
  try {
    var pending = window.__pinnedCard;
    if (!pending || !pending.promise) return;

    var grid = document.querySelector('.product-grid');
    if (!grid) return;

    pending.promise.then(function (html) {
      if (!html || !html.trim()) return;

      var idMatch = html.match(/data-product-id=\"(\d+)\"/);
      if (idMatch) {
        var dupe = grid.querySelector('li[data-product-id=\'' + idMatch[1] + '\']');
        if (dupe) dupe.remove();
      }

      grid.insertAdjacentHTML('afterbegin', html);

      var limitParam = pending.limit;
      if (isFinite(limitParam) && limitParam > 0) {
        var items = grid.querySelectorAll(':scope > li');
        items.forEach(function (li, i) { if (i >= limitParam) li.remove(); });
      }
    }).catch(function () {});
  } catch (e) {}
})();
